import React from 'react'
import { AppBar } from '@mui/material'
import { HeaderContainer } from './Header.styled'
import NavigationMenu from './NavigationMenu/NavigationMenu'
import HeaderLogo from './HeaderLogo/HeaderLogo'
import UserSection from './UserSection/UserSection'
import SideBarMenu from './SideBarMenu/SideBarMenu'
import withCapabilities from '../../hoc/withCapabilities'
import { MenuItem } from '../../types/menuItem.types'
import { HEADER_HEIGHT, PAGE_MAX_WIDTH, PAGE_LEFT_RIGHT_PADDING } from '../../theme'
import GridContainer from '../Grid/GridContainer'
const Header: React.FC<{ mainMenuItems: MenuItem[]; avatarMenuItems: MenuItem[] }> = ({ mainMenuItems, avatarMenuItems }) => {
  return (
    <AppBar position="sticky" sx={{ backgroundColor: 'text.primary' }}>
      <HeaderContainer
        sx={{
          px: PAGE_LEFT_RIGHT_PADDING,
          width: '100%',
          maxWidth: PAGE_MAX_WIDTH,
          margin: '0 auto',
          height: HEADER_HEIGHT,
        }}
      >
        {/*------------ Left Side - Logo ------------*/}
        <HeaderLogo />

        <GridContainer>
          {/*------------  Menu ------------*/}
          <NavigationMenu items={mainMenuItems} desktopOnly />
          {/*------------ Icon and Username ------------*/}
          <UserSection items={avatarMenuItems} desktopOnly />
        </GridContainer>

        {/*On mobile them menu is show in the right side and the logo on the left side*/}
        <SideBarMenu menuItems={mainMenuItems.concat(avatarMenuItems)} openFrom="right" mobileAndTabletOnly />
      </HeaderContainer>
    </AppBar>
  )
}

export default withCapabilities(Header)
